import * as React from 'react'
import MenuItem from '@mui/material/MenuItem'
import { ListSubheader, Select, SelectChangeEvent, Typography, Tooltip } from '@mui/material'
import { groupBy } from '../utility'
import { appdata } from '../internalModules'
import { dialogTypographyStyle, rowHeight } from '../Graphics'

type Props = {
  label: string
  hideGwpByArea: boolean
  propertyName: string
  materialGuid: string
  disabled?: boolean
  handleChange: ((event: SelectChangeEvent<string>, child: React.ReactNode) => void) | undefined
}

export default function UISelectMaterial( {label, hideGwpByArea, propertyName, materialGuid, disabled = false, handleChange}: Props ) {
  //get materials and group materials by category
  let materials = appdata.getMaterialArray()
  if (hideGwpByArea){
    materials = materials.filter( x => x.gwpByArea === 0)
  }
  const grouped = groupBy(materials, ['category'])
  const sortedCategories = Object.keys(grouped).sort( (a, b) => a.localeCompare(b))
  return (
    <>
      <Tooltip title='Select a material from the list or use the "Materials" menu to create new materials.' arrow placement='left'>
        <Typography sx={dialogTypographyStyle} color='secondary'>{label}</Typography>
      </Tooltip>
      <Select
        disabled={disabled}
        size='small'
        fullWidth
        labelId='material-select-label'
        value={materialGuid}
        name={propertyName}
        onChange={handleChange}
        style={{height: rowHeight}}
      >
        <MenuItem disabled value=''>
          <em>Use "Materials" menu to create new materials...</em>
        </MenuItem>
        {sortedCategories.map(category => [
          <ListSubheader color={'primary'} sx={{fontSize:'18px'}} key={category}>{category}</ListSubheader>,
          grouped[category].sort( (a, b) => a.name.localeCompare(b.name)).map(m => (
            <MenuItem sx={{paddingLeft:4, height:rowHeight}} key={m.guid} value={m.guid}>{m.nameInfo}</MenuItem>
          ))
        ])}
      

      </Select>
    </>  
  )

}
